import React from 'react'
import { useState } from 'react'
import Prism from 'prismjs'
import styled from 'styled-components'
import { useWindowSize } from 'react-use'
import { breakpoints } from '@styles/responsive'
import { PrismStyle } from '@styles/prism-theme'

const CodeViewBox = styled.div`
  position: fixed;
  top: 60px;
  right: 0;
  width: calc((100vw - 250px) * 0.4);
  height: calc(100vh - 60px);
  background-color: rgb(37, 37, 46);
  padding: 20px;
  color: white;
  overflow: auto;

  &.sm {
    position: static;
    width: 100%;
    height: auto;
    border-radius: 5px;
  }
`

const LangList = styled.div`
  display: flex;
  align-items: center;
  background-color: rgb(24, 24, 29);
  padding: 16px 30px;
  border-radius: 23px;
`

const LangItem = styled.div<{ active: boolean }>`
  margin: 0 15px;
  font-size: 14px;
  line-height: 14px;
  color: ${p => (p.active ? 'rgb(255, 255, 255)' : 'rgba(255, 255, 255, 0.6)')};
  cursor: pointer;
  user-select: none;
`

const PreBoxTitle = styled.div`
  margin-top: 20px;
  font-size: 15px;
  font-weight: 600;
`

const PreBox = styled.pre`
  width: 100%;
  overflow-x: auto;
  font-size: 14px;
  background-color: rgb(24, 24, 29);
  padding: 10px;
  border-radius: 5px;
  white-space: pre-wrap;
`

export const CodeView = ({ list = [] }) => {
  if (!list.length) return null
  const { width } = useWindowSize()
  const isAtLeastDesktop = width > breakpoints.tablet
  const defaultItem = list.find(item => item.lang === 'default')
  const langs = list.map(item => item.lang).filter(item => item !== 'default')
  const [lang, setLang] = useState(langs[0])

  const renderList = []
  const conf = list.find(item => item.lang === lang)

  if (defaultItem && defaultItem.blockList && defaultItem.blockList.length) {
    defaultItem.blockList.forEach(
      ({ title = '', desc = '', code = '', lang: blockLang = '' }) => {
        const curBlock =
          (conf &&
            conf.blockList &&
            conf &&
            conf.blockList.find(item => item.title === title)) ||
          {}

        const codeHtml =
          ((curBlock.code || code) &&
            Prism.highlight(
              (curBlock.code || code)
                .replace(/\n{2,}/g, '\n')
                .replace(/\\"/g, '\\"'),
              (blockLang.toLowerCase() &&
                Prism.languages[blockLang.toLowerCase()]) ||
                (lang.toLowerCase() && Prism.languages[lang.toLowerCase()]) ||
                Prism.languages.clike,
              lang.toLowerCase() || 'clike'
            )) ||
          ''
        renderList.push({
          title,
          desc: curBlock.desc || desc,
          code: codeHtml,
        })
      }
    )
  }

  return (
    <CodeViewBox className={isAtLeastDesktop ? '' : 'sm'}>
      <PrismStyle />
      <LangList>
        {langs.map(langItem => {
          return (
            <LangItem
              key={langItem}
              active={langItem === lang}
              onClick={() => {
                setLang(langItem)
              }}
            >
              {langItem}
            </LangItem>
          )
        })}
      </LangList>

      {renderList.map(rendered => {
        return (
          <div key={rendered.title}>
            <PreBoxTitle>{rendered.title}</PreBoxTitle>
            <PreBox
              className={isAtLeastDesktop ? '' : 'sm'}
              dangerouslySetInnerHTML={{ __html: rendered.code }}
            />
          </div>
        )
      })}
    </CodeViewBox>
  )
}
